function setSubmitButtonState(checkbox) {
	var containerDom = document.getElementById("container");
	var numInputFields = containerDom.querySelectorAll(".input-field-full").length;
	var selectedInputFields = containerDom.getElementsByClassName("selected").length;

	var submitBtn = document.getElementById("submitDocs");
	var enableSubmit = checkbox.checked || numInputFields === selectedInputFields;

	if (submitBtn.disabled && enableSubmit || !submitBtn.disabled && !enableSubmit) {
		submitBtn.classList.toggle("button-gray");
		submitBtn.classList.toggle("button-orange");
	}
	submitBtn.disabled = !enableSubmit;
}

function showFileInfo(fileInput) {
	var message = "";
	var errorMessage = "";

	if ('files' in fileInput) {
		for (var i = 0; i < fileInput.files.length; i++) {
			var file = fileInput.files[i];
			if ('name' in file) {
				message += "<span>" + file.name + "</span>";
			}
			else {
				message += "<span>" + file.fileName + "</span>";
			}
			if (file.size > 4049600) { // 4mb
				errorMessage = "Filen " + file.name + " er for stor, maks størrelse er 4 MB.";
				break;
			}
		}
		if (fileInput.files.length > 1) message = "<span>" + fileInput.files.length + "filer valgt...</span>";
	}

	var error = document.getElementById("errorMessage");
	var info = fileInput.parentElement.querySelectorAll("#fileInfo")[0];
	error.innerHTML = errorMessage;

	if (errorMessage.length > 0) {
		fileInput.value = "";
		fileInput.parentElement.classList.remove('selected');
	} else {
		info.innerHTML = message + info.innerHTML;
		fileInput.parentElement.classList.add('selected');
	}
	setSubmitButtonState(document.getElementById("later2"));
}

function clearFileInput(elem) {
	//elem.querySelectorAll("span").forEach(el => el.remove()); <= gives uglify error
	var spans = elem.querySelectorAll('span'), i;
	for (i = 0; i < spans.length; ++i) {
		spans[i].remove();
	}

	var fileUploaderDiv = elem.parentElement;
	fileUploaderDiv.querySelectorAll("#fileInput2")[0].value = "";
	fileUploaderDiv.classList.remove('selected');
	setSubmitButtonState(document.getElementById("later2"));
}
